import { create } from "zustand";

interface ToastState {
  message: string;
  visible: boolean;
  timer: ReturnType<typeof setTimeout> | null;
  show: (message: string, durationMs?: number) => void;
  hide: () => void;
}

export const useToastStore = create<ToastState>((set, get) => ({
  message: "",
  visible: false,
  timer: null,
  show: (message, durationMs = 3000) => {
    const existing = get().timer;
    if (existing) clearTimeout(existing);
    const timer = setTimeout(() => {
      set({ visible: false, timer: null });
    }, durationMs);
    set({ message, visible: true, timer });
  },
  hide: () => {
    const existing = get().timer;
    if (existing) clearTimeout(existing);
    set({ visible: false, timer: null });
  },
}));

export const toast = (message: string, durationMs?: number) =>
  useToastStore.getState().show(message, durationMs);

export type AuthTab = "login";

interface AuthModalState {
  open: boolean;
  tab: AuthTab;
  openAt: (tab?: AuthTab) => void;
  close: () => void;
  setTab: (tab: AuthTab) => void;
}

export const useAuthModalStore = create<AuthModalState>((set) => ({
  open: false,
  tab: "login",
  openAt: (tab = "login") => set({ open: true, tab }),
  close: () => set({ open: false }),
  setTab: (tab) => set({ tab }),
}));

interface SamplesModalState {
  open: boolean;
  show: () => void;
  hide: () => void;
}

export const useSamplesModalStore = create<SamplesModalState>((set) => ({
  open: false,
  show: () => set({ open: true }),
  hide: () => set({ open: false }),
}));

interface LightboxState {
  url: string | null;
  show: (url: string) => void;
  hide: () => void;
}

export const useLightboxStore = create<LightboxState>((set) => ({
  url: null,
  show: (url) => set({ url }),
  hide: () => set({ url: null }),
}));

// Cross-view: a style chosen from 风格广场 that should be auto-applied when
// the next FreeView render runs (with scroll-into-view + pulse animation).
interface PendingStyleState {
  styleId: string | null;
  set: (id: string | null) => void;
  consume: () => string | null;
}

export const usePendingStyleStore = create<PendingStyleState>((set, get) => ({
  styleId: null,
  set: (id) => set({ styleId: id }),
  consume: () => {
    const v = get().styleId;
    set({ styleId: null });
    return v;
  },
}));
